<template>
  <vs-popup class="create-sundry-supplier-popup"
            id="popup"
            title="CREATE OTHER SUPPLIER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Name</small>
                <vs-input v-model="createForm.company_name"   name="company_name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <div class="vx-row">
                <div class="vx-col w-1/3">
                  <ValidationProvider vid="site_telephone" name="site_telephone" rules="required" v-slot="{ errors }">
                    <small class="label">Country Code</small>
                    <v-select :filter-by="myFilter" :clearable="false" placeholder="code" label="isd_code" v-model="createForm.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                      <template v-slot:option="option">
                        <span>{{option.isd_code}} - {{option.name}} </span>
                      </template>
                    </v-select>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col w-2/3">
                  <ValidationProvider vid="telephone" name="telephone" rules="required|tel|min_tel|max_tel" v-slot="{ errors }">
                    <small class="label">Telephone</small>
                    <vs-input  v-model="createForm.telephone" class="w-full"  name="telephone" type="text" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input v-model="createForm.email"   name="email" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="account_currency" name="account_currency" rules="required" v-slot="{ errors }">
                <small class="label">Currency</small>
                <v-select :clearable="false" label="code" v-model="createForm.account_currency" :reduce="option => option.code" :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mt-8 hidden" v-can="'create-edit-sage-supplier'">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sage" name="sage" rules="required" v-slot="{ errors }">
                <small class="label">Sage supplier</small>
                <v-select name="sage" :closeOnSelect="true"
                          v-model="sage" :clearable="false"
                          label="name" :reduce=" option => option.value"
                          :options="[{name: 'none', value: 0}, {name: 'create new supplier', value: 1}, {name: 'link to existing sage supplier', value: 2}]" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div v-if="sage === 2" class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="existing_sage_id" name="existing_sage_id" rules="required" v-slot="{ errors }">
                <small class="label">Existing sage suppliers</small>
                <v-select :clearable="false" label="name" v-model="existing_sage_id" :reduce="option => option.id" :options="sage_suppliers" :dir="$vs.rtl ? 'rtl' : 'ltr'"  @search="onSearch">
                  <template v-slot:option="option">
                    <span>{{option.name}} - {{option.reference}} </span>
                  </template>
                  <template slot="no-options">
                    type to search sage supplier
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const OtherSupplierRepository = RepositoryFactory.get('other_supplier')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SageRepository = RepositoryFactory.get('sage')
  const StaffRepository = RepositoryFactory.get('staff')

  function initialState() {
    return {
      open: false,
      createForm: {},
      countryCodes: [],
      sage: 0,
      sage_suppliers: [],
      existing_sage_id: null,
      created_supplier: {},
      currencies: []
    }
  }

export default {
  name: 'CreateOtherSupplierPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        await this.loadCountrCode()
        await this.loadCurrencies()
        this.open = true;
      } catch (error) {

      }
    },

    async loadCountrCode() {
      this.$vs.loading()
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close()
    },

    async loadCurrencies() {
      this.$vs.loading()
      const {data} =  (await StaffRepository.getCurrencyList()).data
      this.currencies =  data
      this.$vs.loading.close()
    },

    async onClickCreateStaffUser () {
      const vue = this;
      this.$vs.loading()
       try {
         const { data } = (await OtherSupplierRepository.createOtherSupplier(this.createForm)).data
         this.created_supplier = data
         await this.createSageSupplier()
         this.showSuccessMessage('Other supplier created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async createSageSupplier () {
      try {
        if(this.sage === 1){
          let payload = {}
          payload.name = this.created_supplier.company_name
          payload.reference = this.created_supplier.account_number.match(/\d+/)[0]
          await SageRepository.createSupplier(this.created_supplier.id, payload)
        } else if(this.sage === 2) {
          await SageRepository.linkSageSupplier(this.created_supplier.id, { sage_id: this.existing_sage_id })
        }
      }catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onSearch: function (search, loading) {
      if(search.length) {
        loading(true);
        this.fetchSageSuppliers(loading, search, this);
      }
    },
    fetchSageSuppliers: _.debounce( async (loading, search, vm) => {
      try {
        vm.sage_suppliers =  (await SageRepository.getSageSuppliers(`filter[name]=${search}`)).data.data
      } catch (e) {
        if(e.response.status === 401) {
          vm.sage = 0
          vm.showErrorMessage('Authorization has been denied from sage')
        }
      }
      loading(false);
    }, 350),

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-sundry-supplier-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }
</style>
